import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/variables.css';
import './index.css';
// eslint-disable-next-line react/jsx-filename-extension
ReactDOM.render(<App />, document.getElementById('root'));
